<template lang="pug">
div.pad
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required|cnpj", v-slot="{ errors }", :name="nomeAba + '/CNPJ'")
        app-label(label="CNPJ:", :required="true")
        el-input.input(
          name='cnpj'
          v-model="pessoaJuridica.cnpj",
          v-mask="'##.###.###/####-##'",
          :class="{'erro' : errors.length}",
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="16")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Razão social'")
        app-label(label="Razão social:", :required="true")
        el-input.input(
          name='razaoSocial'
          v-model="pessoaJuridica.razaoSocial",
          maxlength="300"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      app-input-telefone(
        :telefones="pessoa.telefones",
        :requiredTelefones="true"
        :nomeAba="nomeAba",
        :observer="observer"
      )
    el-col.inputDiv(:span="16")
      validation-provider(rules="required|email", v-slot="{ errors }", :name="nomeAba + '/E-mail pessoa jurídica'")
        app-label(label="E-mail:", :required="true")
        el-input.input(
          name='email'
          maxlength="100"
          v-model="pessoa.email",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
</template>
<script>
import AppLabel from './AppLabel'
import AppInputTelefone from '@/components/AppInputTelefoneRetificacao'
import { mapActions } from 'vuex'

export default {
  components: {
    AppLabel,
    AppInputTelefone
  },

  props: {

    pessoa: {
      type: Object,
      required: true
    },

    nomeAba: {
      type: String,
      required: true
    },

    observer: {
      required: true
    }
  },

  data () {
    return {
      fone: ''
    }
  },

  computed: {

    pessoaJuridica () {
      return this.pessoa.pessoaJuridica
    }

  },

  methods: {
    ...mapActions('retificacao', ['update']),
    addTelefone (fone) {
      this.pessoaJuridica.telefones.push(fone)
      this.pessoa.telefones = this.pessoaJuridica
      this.fone = ''
    },

    removeTelefone (fone) {
      this.pessoaJuridica.telefones.pop(fone)
      this.pessoa.telefones = this.pessoaJuridica
    },

    hasTelefoneAdded () {
      return this.pessoaJuridica.telefones && this.pessoaJuridica.telefones.length > 0 ? '' : 'required'
    }
  },
  watch: {
    'pessoa.email' (val) {
      this.update({field: 'interessado.pessoa.email', value: val})
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}

.marginTop {
  margin-top: 5px;
}

/deep/ .tag-app-input i{
  color: #9BA0A9 !important;
}

/deep/ .tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

/deep/ .el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}

/deep/ .style {
  color: #9ba0a9 !important;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AppPessoaJuridicaRetificacao.vue